import { useSyncExternalStore } from "react";

export function useIsNarrow(maxWidth = 1024) {
  const query = `(max-width: ${maxWidth}px)`;
  return useSyncExternalStore(
    (callback) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", callback);
      return () => mql.removeEventListener("change", callback);
    },
    () => window.matchMedia(query).matches,
    () => false
  );
}
